import React from 'react';
import PropTypes from 'prop-types';
import {View, Preloader} from '@ab/components';
import template from '../templates/percent';
import Percent from '../collections/percent.cll';

class Calculations extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.STANDBY]: <Preloader />,
        [this.uiStates.INTERACTIVE]: template,
        [this.uiStates.ERROR]: template,
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
        };

        this.collection = new Percent();
    }

    componentReady() {
        this.load();
    }

    async load() {
        const {cardId, date} = this.props;
        try {
            await this.uiStandBy();
            await this.collection.fetch({data: {cardId, date}});
            this.uiInteractive();
        } catch (e) {
            this.errorHandler(e);
        }
    }

    static propTypes = {
        cardId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
    };

    static displayName = 'Statements.Views.Percent';
}

export default Calculations;
